"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    padding: '32px',
    [_theme.default.breakpoints.down('xs')]: {
      padding: '16px 16px 32px'
    }
  }
});
var _default = exports.default = useStyles;